import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { withRouter } from '@bibliocommons/utils-routing';
import { bindAll } from '@bibliocommons/utils-react';
import { getLabel } from '@bibliocommons/utils-filter';
import ActiveFilterToken from '../../ActiveFilterToken';
import '../styles/LinkFilter.scss';

class LinkFilter extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleToggleFilter(e) {
    if (e) {
      e.preventDefault();
    }
    this.props.handleToggleFilter(this.props.fieldId, this.props.filter);
  }

  render() {
    const { fieldId, filter, intl, refFunction } = this.props;
    const value = filter.get('value');
    const label = filter.get('label');
    const count = filter.get('count');
    const applied = filter.get('applied');

    const filterLabel = getLabel(intl, fieldId, label || value);
    const formattedLabel = intl.formatMessage({ id: 'Facets.filterLabelFormat' }, { value: filterLabel, count });

    if (applied) {
      return (
        <span className="cp-link-filter">
          <ActiveFilterToken
            filter={filter}
            handleToggleFilter={this.props.handleToggleFilter}
            fieldId={fieldId}
            filterLabel={filterLabel}
            ref={refFunction}
          />
        </span>
      );
    }

    return (
      <Link
        className="cp-link-filter"
        data-key="filter-link"
        onClick={this.handleToggleFilter}
        ref={refFunction}
        to={`#filter-${fieldId}-${value}`}
        dataKey="filter-link-key"
      >
        {formattedLabel}
      </Link>
    );
  }
}
LinkFilter.propTypes = {
  filter: ImmutablePropTypes.map.isRequired,
  fieldId: PropTypes.string.isRequired,
  handleToggleFilter: PropTypes.func.isRequired,

  refFunction: PropTypes.func
};

export default injectIntl(withRouter(LinkFilter));
